import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-promotions',
  templateUrl: './promotions.component.html',
  styleUrl: './promotions.component.scss'
})
export class PromotionsComponent {
  @Input() public promotionalTexts = [''];

  public isValidText(value: string): boolean {
    return !!value && value.trim().length > 0;
  }
}
